import { setToken, getToken, curlHttp, setStore, getStore } from '@/library/utils'
import api from '../../library/api.service'

export default {
    state: {
        cpu: [],
        internet: [],
        intranet: [],
        iops: [],
        sysdisk: [],
        vpc: [],
    },
    mutations: {
        setCpu(state, value) {
            state.cpu = value
        },
        setInternet(state, value) {
            state.internet = value
        },
        setIntranet(state, value) {
            state.intranet = value
        },
        setIops(state, value) {
            state.iops = value
        },
        setSysdisk(state, value) {
            state.sysdisk = value
        },
        setVpc(state, value) {
            state.vpc = value
        }
    },
    actions: {

    }
}